<div class="container">
    <div class="row justify-content-md-center ">
      <div clas="col col-lg-8">
        <div class="card mb-3">
          <div class="card-header backgroundHeader text-center">
            Mensagem do Sistema
          </div> 
          <div class="card-body backgroundBody text-center">
            <p class="card-text"> Não é possível acessar o manter máquina. Acusamos o BLOQUEIO da inscrição CNPJ/CEI e/ou CPF no Conectividade Social. <br>
              Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO. 
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>